import React, {useEffect} from 'react';
import {MeetingTabs} from './components/MeetingTabs';
import {InvitationDataGrid} from './components/InvitationDataGrid';
import {InvitationReviewsInput} from '../../schema-types/globalTypes';
import {
  accountNameColumn,
  dateUncontactableColumn,
  // reasonUncontactableColumn,
  ownerColumn,
  clientsColumn,
  propositionTypeColumn,
  rtqStatusColumn,
  ecqStatusColumn,
} from './invitationColumns';
import {InvitationFilters} from './InvitationFilters';
import withAutoFormNew from '../../components/AutoForm/AutoFormNew';
import {InvitationFormSchema, InvitationPageProps} from './invitationFormProps';
import {useLocalStorage} from '../../hooks/useLocalStorage';
import {useAutoForm} from '../../components/AutoForm/useAutoForm';

const UncontactableInner: React.FC = () => {
  const [_, setLocalStorage] = useLocalStorage<
    InvitationFormSchema | Record<string, never>
  >('uncontactable', {});
  const {values} = useAutoForm<InvitationFormSchema>();

  useEffect(() => {
    setLocalStorage(values);
  }, [values]);

  // DataGrid columns - using imported column definitions
  const columns = [
    accountNameColumn,
    clientsColumn,
    ownerColumn,
    propositionTypeColumn,
    dateUncontactableColumn,
    rtqStatusColumn(false),
    ecqStatusColumn(false),
  ];

  return (
    <>
      <InvitationFilters />
      <InvitationDataGrid
        inviteStatus={InvitationReviewsInput.UNCONTACTABLE}
        staff={values?.staff}
        search={values?.search}
        columns={columns}
        entityName="uncontactable meetings"
        noDataMessage="No uncontactable meetings found"
      />
    </>
  );
};

const UncontactableWrapped = withAutoFormNew<InvitationFormSchema, InvitationPageProps>(
  UncontactableInner,
  undefined,
  {debugPosition: 'bottom'}
);

export const UncontactablePage: React.FC = () => {
  const [initialValue] = useLocalStorage<InvitationFormSchema>('uncontactable', {
    staff: '',
    search: '',
  });
  return (
    <>
      <MeetingTabs />
      <UncontactableWrapped initialValueOverrides={initialValue} formFields={[]} />
    </>
  );
};
